import React from 'react';
import useCurrentUser from '~/react-hooks/use-current-user';
import { useZiggy } from '~/react-hooks/use-ziggy';
import { Tooltip } from '@vimily/bonjoro-ui-components-v2/Tooltip';

export interface RequireEmailVerificationProps {
  className?: string;
  children: (isEmailVerified: boolean) => JSX.Element | JSX.Element[];
}

export function RequireEmailVerification({
  className,
  children,
}: RequireEmailVerificationProps) {
  const { is_email_verified } = useCurrentUser();
  const { route } = useZiggy();

  return (
    <Tooltip
      disabled={is_email_verified}
      childrenContainerClassName={className}
      content={
        <span>
          Please{' '}
          <a
            href={route('email::verification.notice')}
            target='_blank'
            rel='noopener noreferrer'
          >
            verify your email address
          </a>
          .
        </span>
      }
    >
      {children(is_email_verified)}
    </Tooltip>
  );
}
